import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppContext } from '@prisjakt/ui-app-context';

import feedbackActions from 'src/areas/feedback/actions';

const { open, startChat } = feedbackActions;

enum LoadState {
  INIT = 'init',
  LOADING = 'loading',
  LOADED = 'loaded',
  FAILED = 'failed',
}

export const useFeedback = () => {
  const {
    market: { lazyLoadIntercom },
  } = useAppContext();
  const dispatch = useDispatch();

  const [loadState, setLoadState] = useState(LoadState.INIT);

  const loadFeedback = useCallback(() => {
    // If intercom lazy load is disabled, simply open
    // the standard form
    if (!lazyLoadIntercom) {
      dispatch(open());
      return;
    }

    window.onIntercomLoadedCb = (successful: boolean) => {
      if (!successful) {
        dispatch(open());
        setLoadState(LoadState.FAILED);
      } else {
        setLoadState(LoadState.LOADED);
      }

      window.onIntercomLoadedCb = undefined;
    };

    if (loadState === 'failed') {
      dispatch(open());
    } else {
      if (loadState === 'init') {
        setLoadState(LoadState.LOADING);
      }
      dispatch(startChat());
    }
  }, [lazyLoadIntercom, loadState, dispatch]);

  return { loadState, loadFeedback };
};
